/**
 * Global Redux store.
 * This replaces the classic Flux dispatcher + store wiring.
 */

import { configureStore } from '@reduxjs/toolkit';
import { appReducer } from './appReducer';
import { projectsReducer } from './projectsReducer';
import { userReducer } from './userReducer';
import { organizationReducer } from './organizationReducer';
import { jobsReducer } from './jobsReducer';
import { listenerMiddleware } from '../listeners';
import { registerOrganizationListeners } from '../listeners/organizationListeners';

registerOrganizationListeners();

export const store = configureStore({
    reducer: {
        app: appReducer,
        projects: projectsReducer,
        user: userReducer,
        organization: organizationReducer,
        jobs: jobsReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type ThunkAPI = {
  state: RootState;
  dispatch: AppDispatch;
};